import {BaseUserFlow, UserFlowList} from './BaseUserFlow';

export class UserFlow extends BaseUserFlow {
  /**
   * Userflow should always reset back to NONE.
   *
   * @inheritDoc
   */
  public setNextStep = () => {
    this.setStep(0);

    return 0;
  };

  /**
   * Userflow should always reset back to NONE.
   *
   * @inheritDoc
   */
  public setPreviousStep = () => {
    this.setStep(0);

    return 0;
  };

  /**
   * Builds a list of steps for the user flow.
   *
   * @returns List of available steps.
   */
  public configure(): UserFlowList {
    // Reset the step.
    this.setStep(0);

    // Possible states.
    return [
      // UserFlowStep.None,
      // `${UserFlowStep.Auth}.${UserFlowStep.Placeholder}`,
      // UserFlowStep.OptionsAndExtras,
      // UserFlowStep.Order,
      // `${UserFlowStep.FlightCheck}.${UserFlowStep.Placeholder}`,
      // UserFlowStep.Share,
    ];
  }
}
